import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './core/auth/auth.interceptor';
// Commented out code related to jwt login which we might use later.
// For the moment, we decided to only user Switch-Authentication
// for the first version at least.
// import { LoginComponent } from './views/auth/login/login.component';
// import { RegisterComponent } from './views/auth/register/register.component';
import { NavComponent } from './core/layout/nav/nav.component';
import { FooterComponent } from './core/layout/footer/footer.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from './views/profile/profile.component';
import { GroupMaskComponent } from './views/groups/group-mask/group-mask.component';
import { UIComponentsModule } from './shared/ui-components/ui-components.module';
import { AboutComponent } from './views/static/about/about.component';
import { ImpressumComponent } from './views/static/impressum/impressum.component';
import { FAQComponent } from './views/static/faq/faq.component';
import { ContactComponent } from './views/static/contact/contact.component';
import { MatAccordion } from '@angular/material/expansion';
import { MobilityComponent } from './views/logs/daily/mobility/mobility.component';
import { FoodComponent } from './views/logs/daily/food/food.component';
import { ConsentFormComponent } from './views/auth/consent-form/consent-form.component';
import { PrivacyStatementsComponent } from './views/static/privacy-statements/privacy-statements.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    FooterComponent,
    NavComponent,
    ProfileComponent,
    // LoginComponent,
    // RegisterComponent,
    AboutComponent,
    ImpressumComponent,
    FAQComponent,
    ContactComponent,
    ConsentFormComponent,
    PrivacyStatementsComponent,
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatAccordion,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatListModule,
    UIComponentsModule,
    GroupMaskComponent,
    FoodComponent,
    MobilityComponent,
    MatCheckboxModule,
    MatTooltipModule
  ],
  providers: [
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
